// Client mirror of functions-common/src/charts/engine/limitSeries.ts. Keep in sync.

import type { ChartSeries } from '../types.js'
import { applyTopNAndOther } from './topN.js'

export interface LimitSeriesOptions {
  limit: number
  topN?: number
  other?: boolean
}

export interface LimitSeriesResult {
  series: ChartSeries[]
  dropped: boolean
}

export function limitSeriesCount(
  series: ChartSeries[],
  options: LimitSeriesOptions
): LimitSeriesResult {
  const { limit, topN, other } = options
  const includeOther = other !== false

  const needsTopN = topN != null && series.length > topN
  const exceedsLimit = series.length > limit

  if (!needsTopN && !exceedsLimit) {
    return { series, dropped: false }
  }

  const maxAllowedTopN = includeOther ? limit - 1 : limit
  const effectiveTopN =
    topN != null ? Math.min(topN, maxAllowedTopN) : maxAllowedTopN

  const capped = applyTopNAndOther(series, effectiveTopN, includeOther)
  return {
    series: capped,
    dropped: !includeOther,
  }
}
